/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '@reducers/rootReducer';

import { TWizardAdditionalReportsSetParamsPayload } from './types/wizardAdditionalReportsActionTypes';
import { initialWizardAdditionalReportsState, IWizardAdditionalReportsReducer } from './wizardAdditionalReportsReducer';

export const makeSelectWizardAdditionalReportsState = (state: IRootReducer): IWizardAdditionalReportsReducer =>
    state.wizardAdditionalReports || initialWizardAdditionalReportsState;

export const makeSelectWizardAdditionalReportsParam = (key: keyof TWizardAdditionalReportsSetParamsPayload):
    OutputSelector<IRootReducer, any, (state: IWizardAdditionalReportsReducer) => any> =>
    createSelector(makeSelectWizardAdditionalReportsState, state => state[key]);

export const makeSelectWizardAdditionalReportsIsStepValid = ():
    OutputSelector<IRootReducer, boolean, (state: IWizardAdditionalReportsReducer) => boolean> =>
    createSelector(makeSelectWizardAdditionalReportsState, state => state.isStepValid);
